import { companyList } from '../environments/stock-environment';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';


import { environment } from '../environments/stock-environment';
import { jkGlb, OrmService } from 'jk-service';
//import { sysPages, } from 'sys';
import { LazyLoadingService } from 'jk-service';
import { appPages, moduleConfigs } from './app.routes';
import { HttpClient } from '@angular/common/http';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { stkPages, } from './stk/_stk';
import { mtrPages } from 'mtr'; // libs/mtr/src/public-api
ModuleRegistry.registerModules([AllCommunityModule]);// ###

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  providers: [],
  styleUrl: './app.component.css'
})
export class AppComponent {
  private lazyLoadingService = inject(LazyLoadingService);
  http = inject(HttpClient);

  orm: OrmService = inject(OrmService);
  constructor() {
    // Initialize ORM service in jkGlb before calling init
    //jkGlb.initOrm(this.orm);
    this.lazyLoadingService.setModuleConfigs(moduleConfigs);
    this.appInit();

  }
  async ngOnInit() {
    // Start preloading critical modules after app initialization
    try {
      await this.lazyLoadingService.preloadAllModules();
    } catch (error) {
      console.error('Error preloading critical modules:', error);
    }
  }

  appInit() {
    //appPages.unshift(...sysPages);
    appPages.unshift(...stkPages);
    appPages.unshift(...mtrPages);
    //console.log('appPages', appPages);
    //routes.unshift(...stkRoutes);
    //console.log('routes', routes);
    jkGlb.init(false, environment as any, companyList, appPages, this.orm);

  }


}
